import React, { Component } from "react";

export default class Discount extends Component {
    render() {
        return null

        if (!this.props.variations[0]) { return null; };
        var variation = this.props.variations[0];

        if (!variation.onSale) {
            return null;
        }
        
        var discount = Math.floor((parseInt(variation.price.replace("$", "")) / parseInt(variation.regularPrice.replace("$", "")) - 1) * 100);

        return <div className="discount-label">
            {discount}%
        </div>

    }
}